/*!
 * @license
 * Copyright © 2005-2025 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The interval to Set
 */
export interface RequestFacetSet {
    /**
     * A label to use to identify the set
     */
    label?: string;
    /**
     * The start of the range
     */
    start?: string;
    /**
     * The end of the range
     */
    end?: string;
    /**
     * When true, the set will include values greater or equal to \"start\"
     */
    startInclusive?: boolean;
    /**
     * When true, the set will include values less than or equal to \"end\"
     */
    endInclusive?: boolean;
}
